export default __webpack_public_path__ + "static/media/mobile-how-work.535ac3f7.svg";